import { ColumnDef } from "@tanstack/react-table";

import { IPatientList } from "@/app/mock-data/getPatientsList";
import { HeaderTitle } from "../../invites/table-items/HeaderTitle";
import { TranslatedItem } from "@/components/ui/table-items/TranslatedItem";
import { SortButton } from "@/components/ui/table-items/SortButton";
import { ViewPatientButton } from "../table-items/ViewPatientButton";

export const searchColumns: ColumnDef<IPatientList>[] = [
  {
    accessorKey: "surnames",
    header: ({ column }) => {
      return (
        <SortButton
          title="patients.search.table.keys.surnames"
          handleClick={() =>
            column.toggleSorting(column.getIsSorted() === "asc")
          }
        />
      );
    },
  },
  {
    accessorKey: "firstname",
    header: () => {
      return <HeaderTitle title="patients.search.table.keys.firstname" />;
    },
  },
  {
    accessorKey: "email",
    header: () => {
      return <HeaderTitle title="patients.search.table.keys.email" />;
    },
  },
  {
    accessorKey: "module",
    header: () => {
      return <HeaderTitle title="patients.search.table.keys.module" />;
    },
    cell: ({ row }) => {
      const { module } = row.original;
      return <TranslatedItem title={`modules.${module.name}`} />;
    },
  },
  {
    id: "condition",
    accessorFn: (row) => row.disease.name,
    header: () => <HeaderTitle title="patients.search.table.keys.condition" />,
    cell: ({ row }) => {
      const { disease } = row.original;
      return (
        <TranslatedItem title={`conditions.${disease.name.toLowerCase()}`} />
      );
    },
  },
  {
    header: () => {
      return <HeaderTitle title="patients.search.table.keys.data" />;
    },
    id: "actions",
    cell: ({ row }) => {
      return <ViewPatientButton patient={row.original} />;
    },
  },
];
